export enum EditionDeployStatus {
  Queued = 'queued',
  NotDeployed = 'not_deployed',
  Failed = 'failed',
  Broadcast = 'broadcast',
  Mined = 'mined',
  Verified = 'verified',
  VerifyError = 'verify_error'
}
